import React from 'react';
// Import the progress bar component
import { Container, Row, Col, Button, Form } from 'react-bootstrap';

const Step3 = () => {

    return (
        <>
            <Form >
                {/* Fundraising Setup */}
                <Form.Group controlId="tokenPrice">
                    <Form.Label>Token Price (e.g., 1 USDT/token)</Form.Label>
                    <Form.Control
                        type="number"
                        step="0.0001"
                        placeholder="Enter token price (e.g., 1)"
                        required
                    />
                </Form.Group>

                <Row className="mt-3">
                    <Col md={6}>
                        <Form.Group controlId="softCap">
                            <Form.Label>Soft Cap (Minimum funding goal)</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter soft cap"
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="hardCap">
                            <Form.Label>Hard Cap (Maximum funding goal)</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter hard cap"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>

                {/* Investment Limits */}
                <Form.Group controlId="maxTokensPerWallet" className="mt-3">
                    <Form.Label>Max Tokens Per Wallet</Form.Label>
                    <Form.Control
                        type="number"
                        placeholder="Enter max tokens a wallet can purchase (optional)"
                    />
                    <Form.Text className="text-white">
                        Leave blank if no limit.
                    </Form.Text>
                </Form.Group>

                {/* Schedule Fundraising */}
                <Row className="mt-4">
                    <Col md={6}>
                        <Form.Group controlId="startDate">
                            <Form.Label>Fundraising Start Date/Time</Form.Label>
                            <Form.Control type="datetime-local" required />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="endDate">
                            <Form.Label>Fundraising End Date/Time</Form.Label>
                            <Form.Control type="datetime-local" required />
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </>
    );
};

export default Step3;
